import type { SavedFilterViewMessages } from '~/hooks/useSavedFilterViews';

export function savedViewMessages(
  translate: (key: string) => string,
  keyPrefix: string
): SavedFilterViewMessages {
  const viewsCopy = (key: string) => translate(`${keyPrefix}.views.${key}`);
  return {
    saveFailed: viewsCopy('error_save_failed'),
    saved: viewsCopy('toast_saved'),
    updated: viewsCopy('toast_updated'),
    updateFailed: viewsCopy('error_update_failed'),
    renameFailed: viewsCopy('error_rename_failed'),
    deleteFailed: viewsCopy('error_delete_failed'),
    activateFailed: viewsCopy('error_activate_failed'),
    clearFailed: viewsCopy('error_clear_failed'),
  };
}
